import getApolloClient from './apolloClient'
import gql from 'graphql-tag'
import store from '../store/index'
import Vue from 'vue'

export default class CatalogueApi {
  // constructor() {}

  async getResourcesGroups(id, take, skip) {
    let getResourcesGroups = await import('./graphql/resources/getResourcesGroups.graphql')
    return (await getApolloClient())
      .query({
        query: gql`${getResourcesGroups}`,
        variables: {
          id: id,
          take: take,
          skip: skip }
      })
      .then(this.getResourcesGroupsCallback)
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  getResourcesGroupsCallback(response) {
    let items = response.data.resourcesGroups
    // store.commit('setResourceGroups', items)
    return items
  }

  async getResources(group, allIncludedGroups, take, skip) {
    let getResources = await import('./graphql/resources/getResources.graphql')
    return (await getApolloClient())
      .query({
        query: gql`${getResources}`,
        variables: {
          group: group,
          allIncludedGroups: allIncludedGroups,
          take: take,
          skip: skip}
      })
      .then(this.getResourcesCallback)
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  getResourcesCallback(response) {
    let items = response.data.resources
    // store.commit('addResources', items)
    return items
  }

  async getResourceById(id) {
    let getResourceById = await import('./graphql/resources/getResourceById.graphql')
    return (await getApolloClient())
      .query({
        query: gql`${getResourceById}`,
        variables: { id: id }
      })
      .then(this.getResourcesCallback)
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  async getMeasurementsByName(str) {
    let getMeasurements = await import('./graphql/resources/getMeasurements.graphql')
    return (await getApolloClient())
      .query({
        query: gql`${getMeasurements}`,
        variables: { name: str }
      })
      // .then(this.getMeasurementsCallback)
      .catch(error => Vue.prototype.$log_error(error.message))
  }
  getMeasurementsCallback(response) {
    let items = response.data.mesurementUnit
    store.commit('setMesurementUnit', items)
    return items
  }
}
